module.exports = __webpack_public_path__ + "img/namad.373a0d32.png";